/*
 * @Description:
 * @Author: Teemo D
 * @Date: 2021-03-23 16:11:05
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 14:44:45
 * @FilePath: /unifyxp-v2-store-portal/src/components/DragRowDisplay/InputSelectAndDelete/index.tsx
 */

import React from 'react';

import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { Input } from '@/src/components/Antd';
import { Field, antdErrorDisplayAdaptor } from 'src/components/RcForm';

//import css from './css.less';
import LinkLibrary from '@/src/constrains/LinkLibrary';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { get } from 'lodash';
import { DeleteOutlined } from '@ant-design/icons';
import css from './css.module.less';
const InputSelectAndDelete = (props: any) => {
  const {
    inputTitle = '',
    linkSet,
    hideLink,
    textName,
    textValidator,
    textMaxLength = 50,
    linkName,
    linkValidator,
    onDelete,
    hideDelete,
    disabled,
  } = props;

  return (
    // <div className={css.container}>
    <Section hasBottomBorder>
      <ItemWrapper
        title={inputTitle}
        rightPart={
          hideDelete ? null : (
            <DeleteOutlined rev className={css.delete} onClick={onDelete} />
          )
        }>
        <Field
          name={textName}
          rules={[
            {
              // validateTrigger: 'onSubmit',
              validator: async (rules: any, value: any) => {
                if (textValidator) {
                  const res = textValidator(value);

                  const hasError = get(res, 'hasError');
                  const errors = get(res, 'errors');
                  if (hasError) {
                    return Promise.reject(new Error((errors || []).join(',')));
                    //</ItemWrapper>throw Error((errors || []).join(','));
                  }
                }
              },
            },
          ]}>
          {(props, m) => {
            const eP = antdErrorDisplayAdaptor(m);
            return (
              <Input
                disabled={disabled}
                maxLength={textMaxLength}
                size='large'
                {...props}
                {...m}
                {...eP}
              />
            );
          }}
        </Field>
      </ItemWrapper>
      {!hideLink && (
        <Field
          name={linkName}
          rules={[
            {
              validator: async (rules: any, value: any) => {
                if (linkValidator) {
                  const res = linkValidator(value);

                  const hasError = get(res, 'hasError');
                  const errors = get(res, 'errors');
                  if (hasError) {
                    return Promise.reject(new Error((errors || []).join(',')));
                    //</ItemWrapper>throw Error((errors || []).join(','));
                  }
                }
              },
            },
          ]}>
          {(props, meta) => {
            const value = props.value;
            const onChange = props.onChange;
            const errors = get(meta, 'errors');
            return (
              <LinkLibrary
                disabled={disabled}
                error={(errors || []).join(' ')}
                data={value}
                onChange={onChange}
                linkSet={linkSet}
              />
            );
          }}
        </Field>
      )}
    </Section>
  );
};

export default InputSelectAndDelete;
